module.exports = __webpack_public_path__ + "static/img/tongxiangongren.d5b3a32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/tongxiangongren.jpg
// module id = TzV9
// module chunks = 4